export const productTypeNames = {
    SAVINGS_ACCOUNT: 'Savings account',
    HIGH_YIELD_CD: 'High-yield CD',
    NO_PENALTY_CD: 'No penalty CD'
};
export const getProductTypeDisplayName = (productOfferType) => productTypeNames[productOfferType];
